"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _mask3 = _interopRequireDefault(require("./mask.js"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// IE* parseFloat polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseFloat#Polyfill
Number.parseFloat = parseFloat;

var CurrencyInput =
/*#__PURE__*/
function (_Component) {
  _inherits(CurrencyInput, _Component);

  function CurrencyInput(props) {
    var _this;

    _classCallCheck(this, CurrencyInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyInput).call(this, props));
    _this.prepareProps = _this.prepareProps.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.state = _this.prepareProps(_this.props);
    _this.inputSelectionStart = 1;
    _this.inputSelectionEnd = 1;
    return _this;
  }
  /**
   * Exposes the current masked value.
   *
   * @returns {String}
   */


  _createClass(CurrencyInput, [{
    key: "getMaskedValue",
    value: function getMaskedValue() {
      return this.state.maskedValue;
    }
    /**
     * General function used to cleanup and define the final props used for rendering
     * @returns {{ maskedValue: {String}, value: {Number}, customProps: {Object} }}
     */

  }, {
    key: "prepareProps",
    value: function prepareProps(props) {
      var customProps = _objectSpread({}, props); // babeljs converts to Object.assign, then polyfills.


      delete customProps.onChange;
      delete customProps.onChangeEvent;
      delete customProps.value;
      delete customProps.decimalSeparator;
      delete customProps.thousandSeparator;
      delete customProps.precision;
      delete customProps.inputType;
      delete customProps.allowNegative;
      delete customProps.allowEmpty;
      delete customProps.prefix;
      delete customProps.suffix;
      delete customProps.selectAllOnFocus;
      var initialValue = props.value;

      if (initialValue === null) {
        initialValue = props.allowEmpty ? null : "";
      } else {
        if (typeof initialValue == "string") {
          // Some people, when confronted with a problem, think "I know, I'll use regular expressions."
          // Now they have two problems.
          // Strip out thousand separators, prefix, and suffix, etc.
          if (props.thousandSeparator === ".") {
            // special handle the . thousand separator
            initialValue = initialValue.replace(/\./g, "");
          }

          if (props.decimalSeparator !== ".") {
            // fix the decimal separator
            initialValue = initialValue.replace(new RegExp(props.decimalSeparator, "g"), ".");
          } //Strip out anything that is not a digit, -, or decimal separator


          initialValue = initialValue.replace(/[^0-9-.]/g, ""); // now we can parse.

          initialValue = Number.parseFloat(initialValue);
        }

        initialValue = Number(initialValue).toLocaleString(undefined, {
          style: "decimal",
          minimumFractionDigits: props.precision,
          maximumFractionDigits: props.precision
        });
      }

      var _mask = (0, _mask3["default"])(initialValue, props.precision, props.decimalSeparator, props.thousandSeparator, props.allowNegative, props.prefix, props.suffix),
          maskedValue = _mask.maskedValue,
          value = _mask.value;

      return {
        maskedValue: maskedValue,
        value: value,
        customProps: customProps
      };
    }
    /**
     * Component lifecycle function.
     * Invoked when a component is receiving new props. This method is not called for the initial render.
     *
     * @param nextProps
     * @see https://facebook.github.io/react/docs/component-specs.html#updating-componentwillreceiveprops
     */

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.prepareProps(nextProps));
    }
    /**
     * onChange Event Handler
     * @param event
     */

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this2 = this;

      event.preventDefault();

      var _mask2 = (0, _mask3["default"])(event.target.value, this.props.precision, this.props.decimalSeparator, this.props.thousandSeparator, this.props.allowNegative, this.props.prefix, this.props.suffix),
          maskedValue = _mask2.maskedValue,
          value = _mask2.value;

      event.persist(); // fixes issue #23

      this.setState({
        maskedValue: maskedValue,
        value: value
      }, function () {
        _this2.props.onChange(maskedValue, value, event);

        _this2.props.onChangeEvent(event, maskedValue, value);
      });
    }
    /**
     * onFocus Event Handler
     * @param event
     */

  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      if (!this.theInput) return; //Whenever we receive focus check to see if the position is before the suffix, if not, move it.

      var selectionEnd = this.theInput.value.length - this.props.suffix.length;
      var isNegative = (this.theInput.value.match(/-/g) || []).length % 2 === 1;
      var selectionStart = this.props.prefix.length + (isNegative ? 1 : 0);
      this.props.selectAllOnFocus && event.target.setSelectionRange(selectionStart, selectionEnd);
      this.inputSelectionStart = selectionStart;
      this.inputSelectionEnd = selectionEnd;
    }
    /* eslint-disable */

  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      this.inputSelectionStart = 0;
      this.inputSelectionEnd = 0;
    }
    /* eslint-enable */

    /**
     * Component lifecycle function.
     * @returns {XML}
     * @see https://facebook.github.io/react/docs/component-specs.html#render
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react["default"].createElement("input", _extends({
        ref: function ref(input) {
          _this3.theInput = input;
        },
        type: this.props.inputType,
        value: this.state.maskedValue,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onMouseUp: this.handleFocus
      }, this.state.customProps));
    }
  }]);

  return CurrencyInput;
}(_react.Component);
/**
 * Prop validation.
 * @see https://facebook.github.io/react/docs/component-specs.html#proptypes
 */


CurrencyInput.propTypes = {
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  decimalSeparator: _propTypes["default"].string,
  thousandSeparator: _propTypes["default"].string,
  precision: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  inputType: _propTypes["default"].string,
  allowNegative: _propTypes["default"].bool,
  allowEmpty: _propTypes["default"].bool,
  prefix: _propTypes["default"].string,
  suffix: _propTypes["default"].string,
  selectAllOnFocus: _propTypes["default"].bool
};
CurrencyInput.defaultProps = {
  /* eslint-disable */
  onChange: function onChange(maskValue, value, event) {
    /*no-op*/
  },
  onChangeEvent: function onChangeEvent(event, maskValue, value) {
    /*no-op*/
  },

  /* eslint-enable */
  value: "0",
  decimalSeparator: ".",
  thousandSeparator: ",",
  precision: "2",
  inputType: "text",
  allowNegative: false,
  prefix: "",
  suffix: "",
  selectAllOnFocus: false
};
var _default = CurrencyInput;
exports["default"] = _default;